/* =====================================================================
   TLX Trade Landing · tlx-landing.js
   Stacking cards, magnetic settle, eased section jumps, lead forms.
   No dependencies. Settings come from the Top bar section (#tlx-config).
   ===================================================================== */
(function () {
  'use strict';

  var d = document, root = d.documentElement;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var design = !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var GAP = 8;

  var DEF = {
    stack: { shrink: 0.01, peek: 12, dim: 0.2, levels: 3, phoneShrink: 0.006, phonePeek: 8, editor: true },
    snap:  { on: true, zone: 0.2, phoneZone: 0.12, idle: 140 },
    messages: {
      role: 'Choose the option that describes you.', name: 'Add your name.', email: 'Enter a valid email address.',
      phone: 'Enter a 10-digit phone number.', consent: 'Tick the box so we can contact you.', send: 'That did not send. Try again, or call us.'
    }
  };
  function readConfig() {
    var c = {};
    try { var el = d.getElementById('tlx-config'); if (el) c = JSON.parse(el.textContent); } catch (e) {}
    return { stack: Object.assign({}, DEF.stack, c.stack), snap: Object.assign({}, DEF.snap, c.snap), messages: Object.assign({}, DEF.messages, c.messages) };
  }

  /* ===================================================================
     MOTION: eased scrolling we control (jumps + settle)
     =================================================================== */
  var Motion = (function () {
    var raf = 0, active = false;
    var ease = {
      inOut: function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; },
      out:   function (t) { return 1 - Math.pow(1 - t, 3); }
    };
    function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; active = false; }
    function to(y, o) {
      o = o || {}; stop();
      var max = root.scrollHeight - innerHeight;
      y = clamp(y, 0, Math.max(0, max));
      var from = scrollY, dist = y - from;
      if (!o.smooth || Math.abs(dist) < 2) { scrollTo({ top: y, behavior: 'instant' }); return; }
      var ms = o.ms || [450, 900], dur = Math.min(ms[1], ms[0] + Math.abs(dist) * 0.25);
      var f = o.ease || ease.inOut, t0 = performance.now();
      active = true;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur);
        scrollTo({ top: from + dist * f(k), behavior: 'instant' });
        if (k < 1) raf = requestAnimationFrame(step); else { raf = 0; active = false; }
      })(t0);
    }
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { addEventListener(ev, stop, { passive: true }); });
    addEventListener('keydown', function (e) {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) > -1) stop();
    });
    return { to: to, stop: stop, ease: ease, isActive: function () { return active; } };
  })();

  /* ===================================================================
     STACK: section wrappers with .tlx-card pin, shrink and dim
     =================================================================== */
  var Stack = (function () {
    var stack = d.getElementById('tlx-stack');
    var C = readConfig(), cards = [], foot = null, on = false;
    var base = [], top = [], h = [], nat = [], vh = 0, hdr = 0, queued = false, ticking = false;
    var observed = new WeakSet();
    var ro = 'ResizeObserver' in window ? new ResizeObserver(function () { relayout(); }) : null;

    function phone() { return innerWidth < 640; }
    function S() { return phone() ? Object.assign({}, C.stack, { shrink: C.stack.phoneShrink, peek: C.stack.phonePeek }) : C.stack; }
    function visibleH() {
      var cb = $('.tlx-callbar');
      return innerHeight - (cb && getComputedStyle(cb).display !== 'none' ? cb.offsetHeight : 0);
    }
    function clear(list) {
      list.forEach(function (c) {
        c.style.top = c.style.minHeight = c.style.transform = c.style.zIndex = '';
        c.style.removeProperty('--tlx-dim');
      });
    }

    function layout() {
      queued = false;
      if (!stack) return;
      C = readConfig();
      clear(cards);
      cards = $$(':scope > .tlx-card', stack);
      foot = $(':scope > .tlx-foot', stack);
      if (ro) cards.forEach(function (c) {
        Array.prototype.forEach.call(c.children, function (k) { if (!observed.has(k)) { observed.add(k); ro.observe(k); } });
      });
      var hb = $('.tlx-hdr');
      hdr = hb && getComputedStyle(hb).display !== 'none' ? hb.offsetHeight : 0;
      stack.style.paddingTop = (hdr + GAP) + 'px';
      on = !reduce.matches && (!design || C.stack.editor);
      root.classList.toggle('tlx-stacking', on);
      if (!on) { clear(cards); return; }

      var s = S(), n = cards.length;
      vh = visibleH();
      root.classList.add('tlx-measure');                       // measure natural positions without sticky
      cards.forEach(function (c, i) {
        base[i] = hdr + GAP + Math.min(i, s.levels) * s.peek;
        var min = vh - base[i];
        if (i === n - 1 && foot) min -= foot.offsetHeight;     // last card + footer fill the final screen
        c.style.minHeight = Math.max(min, 280) + 'px';
      });
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        nat[i] = r.top + scrollY; h[i] = r.height;
        top[i] = Math.min(base[i], vh - h[i]);                 // tall card: scroll through, then pin by its bottom
      });
      root.classList.remove('tlx-measure');
      cards.forEach(function (c, i) { c.style.top = top[i] + 'px'; c.style.zIndex = i + 1; });
      update();
    }
    function relayout() { if (!queued) { queued = true; requestAnimationFrame(layout); } }

    function update() {
      ticking = false;
      if (!on) return;
      var s = S(), n = cards.length, p = [], i;
      for (i = 0; i < n - 1; i++) {
        var start = top[i] + h[i], end = top[i + 1], span = start - end;
        var t = cards[i + 1].getBoundingClientRect().top;
        p[i] = span > 1 ? clamp((start - t) / span, 0, 1) : 0;
      }
      var depth = 0;
      for (i = n - 1; i >= 0; i--) {
        if (i < n - 1) depth += p[i];
        cards[i].style.transform = depth ? 'scale(' + Math.max(0.85, 1 - s.shrink * depth).toFixed(4) + ')' : '';
        cards[i].style.setProperty('--tlx-dim', Math.min(0.6, s.dim * depth).toFixed(3));
      }
    }

    /* scroll so `el` is visible and not covered */
    function reveal(el, smooth) {
      if (!el) return;
      var sm = smooth && !reduce.matches;
      var card = el.closest ? el.closest('.tlx-card') : null;
      var i = cards.indexOf(card);
      if (!on || i < 0) {
        Motion.to(el.getBoundingClientRect().top + scrollY - hdr - GAP, { smooth: sm });
        return;
      }
      var minS = nat[i] - base[i], maxS = nat[i] - top[i], target = minS;
      if (el !== card) {
        var o = 0, node = el;
        while (node && node !== card) { o += node.offsetTop; node = node.offsetParent; }
        target = clamp(nat[i] + o - (vh + base[i]) / 2, minS, maxS);
      }
      Motion.to(target, { smooth: sm });
    }

    /* magnetic settle */
    function points() {
      var max = root.scrollHeight - innerHeight, pts = [0];
      for (var i = 0; i < cards.length; i++) {
        pts.push(nat[i] - base[i]);
        if (top[i] < base[i]) pts.push(nat[i] - top[i]);
      }
      pts.push(max);
      var clean = pts.filter(function (v) { return v >= 0 && v <= max && (v === max || max - v > 100); }).sort(function (a, b) { return a - b; });
      return clean.filter(function (v, k) { return k === 0 || v - clean[k - 1] > 60; });
    }
    var idleT = 0, touching = false, pressed = false;
    function settle() {
      var sn = C.snap;
      if (!on || design || !sn.on || Motion.isActive() || touching || pressed) return;
      var ae = d.activeElement;
      if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return;
      var zone = (phone() ? sn.phoneZone : sn.zone) * vh, y = scrollY, best = null, bd = Infinity;
      points().forEach(function (pt) { var dd = Math.abs(pt - y); if (dd < bd) { bd = dd; best = pt; } });
      if (best !== null && bd > 1 && bd <= zone) Motion.to(best, { smooth: true, ease: Motion.ease.out, ms: [260, 480] });
    }
    function schedule() { clearTimeout(idleT); idleT = setTimeout(settle, C.snap.idle); }

    addEventListener('touchstart', function () { touching = true; }, { passive: true });
    addEventListener('touchend', function () { touching = false; schedule(); }, { passive: true });
    addEventListener('touchcancel', function () { touching = false; schedule(); }, { passive: true });
    addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') pressed = true; }, { passive: true });
    addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') { pressed = false; schedule(); } }, { passive: true });

    /* keyboard: never leave focus on a covered element */
    d.addEventListener('focusin', function (e) {
      if (!on || !e.target.closest) return;
      var card = e.target.closest('.tlx-card'), i = cards.indexOf(card);
      if (i < 0) return;
      var r = e.target.getBoundingClientRect();
      var limit = i < cards.length - 1 ? Math.min(vh, cards[i + 1].getBoundingClientRect().top) : vh;
      if (r.top < base[i] || r.bottom > limit) reveal(e.target, false);
    });

    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
      if (!Motion.isActive()) schedule();
    }, { passive: true });
    addEventListener('resize', relayout);
    addEventListener('load', relayout);
    if (reduce.addEventListener) reduce.addEventListener('change', relayout);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(relayout);

    return { layout: layout, relayout: relayout, reveal: reveal, points: points, isOn: function () { return on; } };
  })();

  /* ===================================================================
     FORMS: contact (Shopify), customer (Shopify), endpoint (fetch)
     =================================================================== */
  var Forms = (function () {
    var q = new URLSearchParams(location.search);
    function slug(s) { return String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function keyOf(n) { var m = /^contact\[(.+)\]$/.exec(n); return m ? m[1] : n; }
    function hp(f) { var x = $('[data-tlx-hp]', f); return x && x.value; }
    function val(f, sel) { var el = $(sel, f); return el ? el.value.trim() : ''; }
    function isEmail(v) { return /^\S+@\S+\.\S+$/.test(v); }
    function leadForm() { return $('form.tlx-lead'); }
    /* messages come from the Top bar section (Form messages) */
    function msg(key) { var m = readConfig().messages; return m[key] || DEF.messages[key]; }

    function track(detail) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('tlx_lead', detail); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', detail); if (window.fbq) window.fbq('track', 'Lead'); } catch (e) {}
    }
    function fillAttribution(f) {
      $$('[data-tlx-utm]', f).forEach(function (i) { i.value = q.get(i.getAttribute('data-tlx-utm')) || ''; });
      $$('[data-tlx-ref]', f).forEach(function (i) { i.value = d.referrer || ''; });
      $$('[data-tlx-page]', f).forEach(function (i) { i.value = location.href.split('#')[0]; });
    }
    function send(f, stage) {
      var ep = f.getAttribute('data-endpoint');
      if (!ep) return Promise.resolve({ demo: true });
      var out = new FormData();
      new FormData(f).forEach(function (v, k) { if (k !== 'form_type' && k !== 'utf8') out.append(keyOf(k), v); });
      if (stage) out.set('Lead stage', stage);
      return fetch(ep, { method: 'POST', body: out, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('send failed'); return {}; });
    }
    /* posted state from a native Shopify submit (page reload) */
    function handlePosted(f, name) {
      var done = $('[data-tlx-done]', f), body = $('[data-tlx-body]', f);
      if (!done || done.hidden) return;
      if (location.hash && location.hash !== '#' + f.id) { done.hidden = true; if (body) body.hidden = false; return; }
      track({ form: name, mode: f.getAttribute('data-mode') });
      setTimeout(function () { Stack.reveal(f, false); }, 80);
    }

    /* ---------- products: tiles <-> step 2 checkboxes ---------- */
    function picked(f) { return f ? $$('[data-tlx-product]:checked', f).map(function (i) { return i.value; }) : []; }
    function syncProducts() {
      var f = leadForm(), list = picked(f), n = list.length;
      $$('[data-tlx-tile]').forEach(function (t) {
        var isOn = list.indexOf(t.getAttribute('data-tlx-tile')) > -1;
        t.classList.toggle('is-on', isOn); t.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });
      $$('[data-tlx-price-selected]').forEach(function (b) {
        var label = b.getAttribute('data-label') || b.textContent;
        b.textContent = n ? label + ' for ' + n + (n > 1 ? ' products' : ' product') : label;
      });
      if (f) {
        var pk = $('[data-tlx-picked]', f);
        if (pk) { pk.hidden = !n; pk.textContent = n ? (pk.getAttribute('data-prefix') || 'Pricing for: ') + list.join(', ') : ''; }
      }
    }
    function toggleProduct(v) {
      var f = leadForm(); if (!f) return;
      var cb = $$('[data-tlx-product]', f).filter(function (i) { return i.value === v; })[0];
      if (!cb) {                                           // tile with no matching checkbox: add one
        var wrap = $('[data-tlx-checks]', f); if (!wrap) return;
        var l = d.createElement('label'); cb = d.createElement('input');
        cb.type = 'checkbox'; cb.value = v; cb.setAttribute('data-tlx-product', '');
        l.appendChild(cb); l.appendChild(d.createTextNode(' ' + v)); wrap.appendChild(l);
      }
      cb.checked = !cb.checked;
      syncProducts();
    }
    function setRole(v) {
      var f = leadForm(); if (!f || !v) return;
      v = v.toLowerCase();
      var r = $$('input[name="contact[Role]"]', f).filter(function (i) { return i.value.toLowerCase() === v; })[0] ||
              $$('input[name="contact[Role]"]', f).filter(function (i) { return i.value.toLowerCase().indexOf(v) === 0; })[0];
      if (r) r.checked = true;
    }
    function goToForm() {
      var f = leadForm(); if (!f) return;
      Stack.reveal(f.closest('[data-tlx-anchor]') || f, true);
      setTimeout(function () { var i = $('[data-tlx-first]', f); if (i) i.focus({ preventScroll: true }); }, 550);
    }

    /* ---------- contact mode: mirror a standard theme contact form ----------
       Post only name, email, industry and body (like the theme's own contact form).
       Everything else is written into the message body as plain labelled lines, with
       no URLs, so Shopify's spam filter has nothing unusual to flag.
       Wording, subject line and routing note come from the "TLX: Lead email" section. */
    var MAIL_DEF = {
      trade:    { subject: '[Trade lead] {role} - {name}', note: '' },
      callback: { subject: '[Callback request] {name}', note: '' },
      headings: { subject: 'SUBJECT', note: 'NOTE FOR RECIPIENT', details: 'LEAD DETAILS' },
      labels: { form: 'Form', name: 'Name', email: 'Email', role: 'Role', phone: 'Phone', company: 'Company', products: 'Products',
                timeline: 'Timeline', details: 'Project details', consent: 'Consent to be contacted', campaign: 'Campaign',
                source: 'Source', medium: 'Medium', content: 'Content' },
      consentYes: 'Yes', consentNo: 'No'
    };
    function mailCfg() {
      var c = {};
      try { var el = d.getElementById('tlx-mail'); if (el) c = JSON.parse(el.textContent); } catch (e) {}
      function pick(k) { return Object.assign({}, MAIL_DEF[k], c[k]); }
      var labels = Object.assign({}, MAIL_DEF.labels);
      Object.keys(c.labels || {}).forEach(function (k) { if (c.labels[k]) labels[k] = c.labels[k]; });
      var heads = Object.assign({}, MAIL_DEF.headings);
      Object.keys(c.headings || {}).forEach(function (k) { if (c.headings[k]) heads[k] = c.headings[k]; });
      return { trade: pick('trade'), callback: pick('callback'), labels: labels, headings: heads,
               consentYes: c.consentYes || MAIL_DEF.consentYes, consentNo: c.consentNo || MAIL_DEF.consentNo };
    }
    function fillTokens(t, v) {
      return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return v[k] || ''; })
        .replace(/[ \t]+/g, ' ').replace(/(\s[-\u2013:|])+\s*$/, '').replace(/^\s*[-\u2013:|]\s*/, '').trim();
    }
    var KEEP = ['contact[name]', 'contact[email]', 'contact[industry]', 'contact[body]'];
    function composeContact(f, kind) {
      var M = mailCfg(), L = M.labels, H = M.headings, cfg = M[kind] || M.trade;
      var g = function (sel) { var el = $(sel, f); return el ? String(el.value || '').trim() : ''; };
      var role = ($('input[name="contact[Role]"]:checked', f) || {}).value || '';
      var cons = $('[data-tlx-consent]', f);
      var data = {
        form: g('[name="contact[Lead form]"]'), name: g('[name="contact[name]"]'), email: g('[name="contact[email]"]'),
        role: role, phone: g('[name="contact[phone]"]'), company: g('[name="contact[Company]"]'),
        products: g('[data-tlx-products]'), timeline: g('[name="contact[Timeline]"]'), details: g('[name="contact[Details]"]'),
        campaign: g('[data-tlx-utm="utm_campaign"]'), source: g('[data-tlx-utm="utm_source"]'),
        medium: g('[data-tlx-utm="utm_medium"]'), content: g('[data-tlx-utm="utm_content"]')
      };
      var rule = new Array(35).join('=');
      var out = [], subject = fillTokens(cfg.subject, data), note = String(cfg.note || '').trim();
      if (subject) out.push(H.subject + ': ' + subject, rule);
      if (note) out.push(H.note, note, rule);
      out.push(H.details);
      ['form', 'name', 'email', 'role', 'phone', 'company', 'products', 'timeline', 'details'].forEach(function (k) {
        if (k === 'email' && kind === 'callback') return;           // callback sends the store's own address: not the lead's
        if (data[k]) out.push(L[k] + ': ' + data[k]);
      });
      out.push(L.consent + ': ' + (cons && cons.checked ? M.consentYes : M.consentNo));
      ['campaign', 'source', 'medium', 'content'].forEach(function (k) { if (data[k]) out.push(L[k] + ': ' + data[k]); });
      var ind = $('[data-tlx-industry]', f); if (ind) ind.value = role;
      var body = $('[data-tlx-body-field]', f); if (body) body.value = out.join('\n');
      $$('[name^="contact["]', f).forEach(function (el) { if (KEEP.indexOf(el.name) < 0) el.removeAttribute('name'); });
    }

    /* ---------- trade pricing form (2 steps) ---------- */
    function prepare(f) {
      var list = picked(f), agg = $('[data-tlx-products]', f);
      if (agg) agg.value = list.join(', ');
      if (f.getAttribute('data-mode') === 'contact') { composeContact(f, 'trade'); return; }
      if (f.getAttribute('data-mode') !== 'customer') return;
      var parts = val(f, '[data-tlx-first]').split(/\s+/);
      var fn = $('[data-tlx-fname]', f), ln = $('[data-tlx-lname]', f);
      if (fn) fn.value = parts.shift() || '';
      if (ln) ln.value = parts.join(' ');
      var role = ($('input[name="contact[Role]"]:checked', f) || {}).value;
      var tl = val(f, '[data-tlx-timeline]');
      var tags = (f.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      if (role) tags.push('role-' + slug(role));
      list.forEach(function (p) { tags.push('product-' + slug(p)); });
      if (tl) tags.push('timeline-' + slug(tl));
      if (q.get('utm_source')) tags.push('source-' + slug(q.get('utm_source')));
      if (q.get('utm_campaign')) tags.push('campaign-' + slug(q.get('utm_campaign')));
      var tg = $('[data-tlx-tags]', f); if (tg) tg.value = tags.join(', ');
      /* the customer form only accepts these fields: drop the rest so Shopify does not reject the post */
      var allowed = ['contact[email]', 'contact[first_name]', 'contact[last_name]', 'contact[tags]'];
      $$('[name^="contact["]', f).forEach(function (el) { if (allowed.indexOf(el.name) < 0) el.removeAttribute('name'); });
    }

    function initLead(f) {
      if (f.getAttribute('data-tlx-init')) return;
      f.setAttribute('data-tlx-init', '1');
      var mode = f.getAttribute('data-mode');
      var s1 = $('[data-tlx-step="1"]', f), s2 = $('[data-tlx-step="2"]', f);
      var e1 = $('[data-tlx-err="1"]', f), e2 = $('[data-tlx-err="2"]', f);
      var body = $('[data-tlx-body]', f), done = $('[data-tlx-done]', f);
      var msgFail = msg('send');
      fillAttribution(f);
      var rp = (q.get('role') || '').toLowerCase();
      if (rp) setRole(rp);
      handlePosted(f, 'trade-pricing');

      function show(n) {
        s1.hidden = n !== 1; s2.hidden = n !== 2;
        var p2 = $('[data-tlx-p2]', f); if (p2) p2.classList.toggle('is-on', n === 2);
        var first = n === 1 ? $('[data-tlx-first]', f) : $('input:not([type=hidden]),select,textarea', s2);
        if (first) first.focus({ preventScroll: true });
        Stack.relayout();
      }
      function step1ok() {
        e1.textContent = ''; e2.textContent = '';
        var radios = $$('input[name="contact[Role]"]', f);
        if (radios.length && !radios.some(function (r) { return r.checked; })) { e1.textContent = msg('role'); return false; }
        if (!val(f, '[data-tlx-first]')) { e1.textContent = msg('name'); $('[data-tlx-first]', f).focus(); return false; }
        if (!isEmail(val(f, '[data-tlx-email]'))) { e1.textContent = msg('email'); $('[data-tlx-email]', f).focus(); return false; }
        var c = $('[data-tlx-consent]', f);
        if (c && !c.checked) { e2.textContent = msg('consent'); c.focus(); return false; }
        return true;
      }
      function next() {
        if (!step1ok()) return;
        if (mode === 'endpoint' && f.getAttribute('data-partial') === 'true' && !hp(f)) { prepare(f); send(f, 'partial').catch(function () {}); }
        show(2);
      }
      $('[data-tlx-next]', f).addEventListener('click', next);
      $('[data-tlx-back]', f).addEventListener('click', function () { show(1); });

      f.addEventListener('submit', function (ev) {
        if (hp(f)) { ev.preventDefault(); return; }
        if (s2.hidden) { ev.preventDefault(); next(); return; }
        if (!step1ok()) { ev.preventDefault(); show(1); return; }
        prepare(f);
        var btn = $('[data-tlx-submit]', f), label = btn.textContent;
        btn.textContent = btn.getAttribute('data-sending') || 'Sending...';
        if (mode !== 'endpoint') { setTimeout(function () { btn.disabled = true; }, 0); return; }   // native Shopify post
        ev.preventDefault();
        btn.disabled = true;
        send(f, 'complete').then(function (r) {
          body.hidden = true; done.hidden = false;
          var dm = $('[data-tlx-demo]', f); if (dm) dm.hidden = !r.demo;
          track({ form: 'trade-pricing', mode: mode, role: ($('input[name="contact[Role]"]:checked', f) || {}).value || '' });
          Stack.relayout();
        }).catch(function () { btn.disabled = false; btn.textContent = label; e2.textContent = msgFail; });
      });
    }

    /* ---------- callback form ---------- */
    function initCb(f) {
      if (f.getAttribute('data-tlx-init')) return;
      f.setAttribute('data-tlx-init', '1');
      var mode = f.getAttribute('data-mode'), err = $('[data-tlx-err]', f);
      var body = $('[data-tlx-body]', f), done = $('[data-tlx-done]', f);
      fillAttribution(f);
      handlePosted(f, 'callback');
      f.addEventListener('submit', function (ev) {
        err.textContent = '';
        if (hp(f)) { ev.preventDefault(); return; }
        var nm = $('[data-tlx-first]', f), ph = $('[data-tlx-phone]', f), c = $('[data-tlx-consent]', f);
        if (!nm.value.trim()) { ev.preventDefault(); err.textContent = msg('name'); nm.focus(); return; }
        if (ph.value.replace(/\D/g, '').length < 10) { ev.preventDefault(); err.textContent = msg('phone'); ph.focus(); return; }
        if (c && !c.checked) { ev.preventDefault(); err.textContent = msg('consent'); c.focus(); return; }
        var btn = $('[data-tlx-submit]', f), label = btn.textContent;
        btn.textContent = btn.getAttribute('data-sending') || 'Sending...';
        if (mode !== 'endpoint') { composeContact(f, 'callback'); setTimeout(function () { btn.disabled = true; }, 0); return; }
        ev.preventDefault(); btn.disabled = true;
        send(f, 'callback').then(function (r) {
          body.hidden = true; done.hidden = false;
          var dm = $('[data-tlx-demo]', f); if (dm) dm.hidden = !r.demo;
          track({ form: 'callback', mode: mode });
          Stack.relayout();
        }).catch(function () { btn.disabled = false; btn.textContent = label; err.textContent = msg('send'); });
      });
    }

    function init(scope) {
      $$('form.tlx-lead', scope).forEach(initLead);
      $$('form.tlx-cbform', scope).forEach(initCb);
      syncProducts();
    }

    /* delegated clicks: work for sections re-rendered in the editor too */
    d.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var tile = e.target.closest('[data-tlx-tile]');
      if (tile) { toggleProduct(tile.getAttribute('data-tlx-tile')); return; }
      var rb = e.target.closest('[data-tlx-role]');
      if (rb) { setRole(rb.getAttribute('data-tlx-role')); goToForm(); return; }
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      if (!id) return;
      if (id === 'top') { e.preventDefault(); Motion.to(0, { smooth: !reduce.matches }); return; }
      var el = d.getElementById(id); if (!el) return;
      e.preventDefault();
      Stack.reveal(el, true);
      var f = el.matches('form.tlx-lead') ? el : $('form.tlx-lead', el);
      if (f) setTimeout(function () { var i = $('[data-tlx-first]', f); if (i) i.focus({ preventScroll: true }); }, 550);
    });
    d.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-tlx-product]')) syncProducts();
    });

    return { init: init };
  })();

  /* ===================================================================
     BOOT + THEME EDITOR
     =================================================================== */
  Forms.init(d);
  Stack.layout();
  if (location.hash.length > 1) {
    var target = d.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) setTimeout(function () { Stack.layout(); Stack.reveal(target, false); }, 120);
  }

  d.addEventListener('shopify:section:load', function (e) { Forms.init(e.target); Stack.relayout(); });
  d.addEventListener('shopify:section:unload', function () { setTimeout(Stack.relayout, 0); });
  d.addEventListener('shopify:section:reorder', function () { setTimeout(Stack.relayout, 0); });
  d.addEventListener('shopify:section:select', function (e) { Stack.layout(); if (e.target.classList.contains('tlx-card')) Stack.reveal(e.target, true); });
  d.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.tagName === 'DETAILS') el.open = true;
    Stack.layout(); Stack.reveal(el, true);
  });

  window.TLX = { Stack: Stack, Motion: Motion };
})();
